import { Controller } from "@hotwired/stimulus"
import { saveListScroll } from "../lib/list_scroll"

// The native feed starts at "/" while its tab links point at /products.
const listPath = (path) => (path === "/" ? "/products" : path.replace(/\/$/, ""))

// Products Index Controller
// 상품 리스트 스트리밍 상태 관리
export default class extends Controller {
  static targets = ["productGrid"]
  static values = {
    streaming: { type: Boolean, default: true }
  }

  connect() {
    // Store bound functions to ensure proper cleanup (prevent memory leak)
    this.boundListClick = this.showRefreshing.bind(this)
    this.boundClearRefreshing = this.clearRefreshing.bind(this)
    this.element.addEventListener("turbo:click", this.boundListClick)
    document.addEventListener("turbo:before-cache", this.boundClearRefreshing)
  }

  disconnect() {
    // Cleanup listeners with same function references
    this.element.removeEventListener("turbo:click", this.boundListClick)
    document.removeEventListener("turbo:before-cache", this.boundClearRefreshing)
  }

  // A tab tap reloads this same list: swap the cards for the skeleton right away, so the
  // wait reads as "loading the new list" instead of a frozen old one. The next page replaces it.
  showRefreshing(event) {
    const url = new URL(event.detail.url, window.location.href)
    if (listPath(url.pathname) !== listPath(window.location.pathname)) return
    const grid = document.getElementById("products-grid")
    grid?.classList.add("is-refreshing")
    grid?.setAttribute("aria-busy", "true")
    window.scrollTo({ top: 0, behavior: "auto" })
  }

  clearRefreshing() {
    const grid = document.getElementById("products-grid")
    grid?.classList.remove("is-refreshing")
    grid?.removeAttribute("aria-busy")
  }

  // Remember where the list was when a card is opened (application.js consumes it on the next render)
  saveScroll(event) {
    saveListScroll(event.currentTarget)
  }
}
